import React, { Component } from "react";
import { Helmet } from "react-helmet";
import Service from "../../components/Service";
import TechBox from "../../components/TechBox";
import TechDetail from "../../components/TechDetail";
import PageTitle from "../../components/PageTitle";
import data from "../../data/Services.json";
import technologies from "../../data/Technologies.json";


class Services extends Component {
    async componentDidMount() { }
    state = {
        sidebarOpen: false,
        technology: technologies.back
    };
    render() {
        
        const { technology } = this.state;
        return (
            <div>
                <Helmet>
                    <title>AsritSolutions | Services</title>
                </Helmet>
                <div>
                    <PageTitle title="Services" />

                    <section className="services-page-section">
                        <div className="auto-container">
                            <div className="sec-title centered">
                                <h2>Service We Provide</h2>
                            </div>

                            <div className="row clearfix">
                                <Service
                                    values={data.web}
                                    
                                />
                                <Service
                                    values={data.mobile}
                                    
                                />
                                <Service
                                   values={data.ecommerce}
                                />
                                <Service
                                   values={data.cloud}
                                />
                                <Service
                                    values={data.uiux}
                                />
                                <Service
                                    values={data.qa}
                                />
                            </div>
                        </div>
                    </section>

                    <section className="service-tabs-section style-two">
                        <div className="auto-container">
                            <div className="sec-title centered">
                                <h2>Technologies</h2>
                            </div>

                            <div className="services-info-tabs">
                                <div className="services-tabs tabs-box">
                                    <ul className="tab-btns tab-buttons clearfix">
                                        <TechBox
                                            title={technologies.back.title}
                                            isActive={
                                                technology === technologies.back
                                            }
                                            
                                            onClick={() => {
                                                this.setState({
                                                    technology: technologies.back
                                                });
                                            }}
                                        />
                                        <TechBox
                                            title={technologies.front.title}
                                            isActive={
                                                technology === technologies.front
                                            }
                                            onClick={() => {
                                                this.setState({
                                                    technology: technologies.front
                                                });
                                            }}
                                        />
                                        <TechBox
                                            title={technologies.native.title}
                                            isActive={
                                                technology === technologies.native
                                            }
                                            onClick={() => {
                                                this.setState({
                                                    technology: technologies.native
                                                });
                                            }}
                                        />
                                        <TechBox
                                            title={technologies.hybrid.title}
                                            isActive={
                                                technology === technologies.hybrid
                                            }
                                            onClick={() => {
                                                this.setState({
                                                    technology: technologies.hybrid
                                                });
                                            }}
                                        />
                                        <TechBox
                                            title={technologies.seo.title}
                                            isActive={
                                                technology === technologies.seo
                                            }
                                            onClick={() => {
                                                this.setState({
                                                    technology: technologies.seo
                                                });
                                            }}
                                        />
                                        <TechBox
                                            title={technologies.qa.title}
                                            isActive={
                                                technology === technologies.qa
                                            }
                                            onClick={() => {
                                                this.setState({
                                                    technology: technologies.qa
                                                });
                                            }}
                                        />
                                    </ul>
                                    <div className="tabs-content">
                                        <TechDetail
                                            headerTitle={technology.header}
                                            desc={technology.desc}
                                            image={technology.image}
                                        />
                                    </div>
                                </div>
                            </div>
                        </div>
                    </section>
                </div>
            </div>
        );
    }
}
export default Services;
